export default "__VITE_ASSET__6_u2aTcN__"